
<div class="wrapper">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div class="loaded-content" [class.blurred]="loading">
    <!--<div class="overlay" *ngIf="loading">
      <div class="spinner-wrapper">
        <app-spinner>
          <span style="font-size: 3em; color: #27AE61;"><i class="fal fa-atom-alt fa-spin"></i></span>
        </app-spinner>
      </div>
    </div>-->
    <div>
      <p-table [hidden]="initialLoad" #reqlist [columns]="cols" [value]="dataRows" [lazy]="true" (onLazyLoad)="loadGridData($event)" [paginator]="true" styleClass="p-datatable-customers"
               [rows]="20" [totalRecords]="totalRecords" [loading]="loading" sortField="ReceivedFromLIMSDate" [sortOrder]="-1">
        <ng-template pTemplate="caption">
          <div style="height: 30px !important; width: 100%">
            <span class="float-left">Review and Approve Results</span>
            <div class="float-right">
              <input pInputText type="text" [(ngModel)]="gridFilter" (keypress)="handleGlobalGridSearchKey($event, reqlist)" placeholder="search..." style="margin-right: 15px;" />
              <a (click)="loadGridData(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
            </div>
            <div class="float-right">
              <p-button (click)="signResultsBatch()" label="Approve Selected" icon="fal fa-file-signature" iconPos="left" class="p-button-outlined mr-3 mb-2"></p-button>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th style="width:35px">&nbsp;</th>
            <th style="width:35px">&nbsp;</th>
            <th pSortableColumn="Accession">Sample ID <p-sortIcon field="Accession"></p-sortIcon></th>
            <th pSortableColumn="PatientFirstName" style="width:125px;">First Name <p-sortIcon field="PatientFirstName"></p-sortIcon></th>
            <th pSortableColumn="PatientLastName" style="width:125px;">Last Name <p-sortIcon field="PatientLastName"></p-sortIcon></th>
            <th pSortableColumn="Birthdate" style="width:100px;">Birth Date <p-sortIcon field="Birthdate"></p-sortIcon></th>
            <th pSortableColumn="ProviderName">Provider <p-sortIcon field="ProviderName"></p-sortIcon></th>
            <th pSortableColumn="FacilityName">Facility <p-sortIcon field="FacilityName"></p-sortIcon></th>
            <th pSortableColumn="ReceivedFromLIMSDate">Received From LIMS Date <p-sortIcon field="ReceivedFromLIMSDate"></p-sortIcon></th>
            <th pSortableColumn="TestName">Test <p-sortIcon field="TestName"></p-sortIcon></th>
            <th pSortableColumn="StatusText">Status <p-sortIcon field="StatusText"></p-sortIcon></th>
            <th pSortableColumn="ReviewedBy">Approved By <p-sortIcon field="ReviewedBy"></p-sortIcon></th>
          </tr>
          <tr>
            <th style="width:35px">
              <input type="checkbox" class="pull-left" title="Select/Deselect All" (click)="setAllSelect($event.target.checked)" />
            </th>
            <th style="width:35px">
              <a style="cursor:pointer" class="pull-right" (click)="clearAllFilters(reqlist)" title="Clear all filters"><i class="fa fa-times"></i></a>
            </th>
            <th class="p-0"><input type="text" style="border:0; width:100%" [(ngModel)]="filterAccession" (keypress)="handleFilterKey($event,   'Accession', reqlist)" /></th>
            <th class="p-0"><input type="text" style="border: 0; width: 100%" [(ngModel)]="filterPatientFirstName" (keypress)="handleFilterKey($event, 'PatientFirstName', reqlist)" /></th>
            <th class="p-0">
              <input type="text" style="border: 0; width: 100%" [(ngModel)]="filterPatientLastName" (keypress)="handleFilterKey($event, 'PatientLastName', reqlist)" />
            </th>
            <th class="p-0">
              <p-datepicker #dobfilter fluid size="small" [style]="{'width':'100%'}" class="w-full" [panelStyle]="{'width':'500px'}" [(ngModel)]="filterDOBDate" inputId="range" (onSelect)="onDOBSelect(dobfilter, reqlist)"></p-datepicker>
            </th>
            <th class="p-0"><input type="text" style="border: 0; width: 100%" [(ngModel)]="filterProviderName" (keypress)="handleFilterKey($event, 'ProviderName', reqlist)" /></th>
            <th class="p-0">
              <p-select [options]="facilityList" [style]="{'width':'95%'}" [(ngModel)]="filterFacilityName" (onChange)="reqlist.filter($event.value.FacilityName, 'FacilityName', 'equals')" optionLabel="FacilityName" optionValue="FacilityName"></p-select>
            </th>
            <th class="p-0">
              <p-datepicker #resultsreceivedfilter [style]="{'width':'100%'}" [panelStyle]="{'width':'500px'}" [(ngModel)]="filterResultsReceivedDates" selectionMode="range" [readonlyInput]="true" inputId="resultsreceivedfilter" (onSelect)="onResultsReceivedRangeSelect(resultsreceivedfilter, reqlist)"></p-datepicker>
            </th>
            <th class="p-0">
              <p-select [options]="labTestList" [style]="{'width':'95%'}" [(ngModel)]="filterTestName" (onChange)="reqlist.filter($event.value.Name, 'TestName', 'equals')" optionLabel="Name" optionValue="Name"></p-select>
              <!--<input type="text" style="border: 0; width: 100%" [(ngModel)]="filterTestName" (keypress)="handleFilterKey($event, 'TestName', reqlist)" />-->
            </th>
            <th class="p-0">
              <p-select [options]="statusList" [style]="{'width':'95%'}" [(ngModel)]="filterStatusText" (onChange)="reqlist.filter($event.value.status, 'StatusText', 'equals')" optionLabel="status" optionValue="status"></p-select>
              <!--<input type="text" style="border: 0; width: 100%" [(ngModel)]="filterStatusText" (keypress)="handleFilterKey($event, 'StatusText', reqlist)" />-->
            </th>
            <th class="p-0">
              <input type="text" style="border: 0; width: 100%" [(ngModel)]="filterReviewedBy" (keypress)="handleFilterKey($event, 'ReviewedBy', reqlist)" />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr>
            <td class="">
              <input *ngIf="row.ReviewedBy == null" type="checkbox" [(ngModel)]="row.selected" />
            </td>
            <td>
              <a style="cursor:pointer" (click)="expandRow(row)"><i class="fa fa-eye"></i></a>
            </td>
            <td>{{row.Accession}}</td>
            <td>{{row.PatientFirstName}}</td>
            <td>{{row.PatientLastName}}</td>
            <td>{{row.Birthdate | date:'shortDate'}}</td>
            <td>{{row.ProviderName}}</td>
            <td>{{row.FacilityName}}</td>
            <td>{{row.ReceivedFromLIMSDate  | date:'short'}}</td>
            <td>{{row.TestName}}</td>
            <td>{{row.StatusText}}</td>
            <td>{{row.ReviewedBy}} <br /><small>{{row.ReviewedDate | date:'short' }}</small></td>
          </tr>
          <tr *ngIf="row.showDetail == true">
            <td colspan="11" style="background-color: lightgray; padding: 15px">
              <app-sign-results-test requisitionTestId="{{row.RequisitionTestId}}" (onSaveTest)="testInfoSaved()"></app-sign-results-test>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
<p-toast>
</p-toast>

